export default "__VITE_ASSET__ClAtUfSN__"